class IntersectionObserverAnimation {
    constructor(selector, 
        //threshold: 0.2 means that the observer will call the callback function when the target is 20% visible
        //rootMargin: '0px' means that the observer will call the callback function when the target is visible
        //null means that the observer will use the viewport as the root
        options = { root: null, rootMargin: '0px', threshold: 0.3 }) {
        this.selector = selector;
        this.elements = document.querySelectorAll(this.selector);
        this.options  = options;
        // Bind the callback so that `this` refers to the class instance
        this.fadeInElement = this.fadeInElement.bind(this);
        this.observer = new IntersectionObserver(this.fadeInElement, this.options);
    }

    trackElement(target) {
        const index = [...Array.from(target.parentElement.children)].indexOf(target);
        const h1    = target.querySelector('h1');
        const h2    = target.querySelector('h2');
        const text  = h1 ? h1.innerText : h2 ? h2.innerText : '-';

        window.dataLayer.push({
            'event': 'section',
            'section_number': index,
            'name': text
        });
    }

    fadeInElement(entries, observer) {
        // Loop through the entries
        entries.forEach(entry => {
            if (entry.isIntersecting) {

                const autoplayVideo = entry.target.querySelector('.video-embed-item[muted]');

                entry.target.classList.add('intersectionObserverFade-in');

                // Call the separate method to handle logging info
                this.trackElement(entry.target);

                // remove the observer after the first time the element is visible
                observer.unobserve(entry.target);

                if (autoplayVideo) autoplayVideo.play();

            } else {
                entry.target.classList.remove('intersectionObserverFade-in');
            }
        });
    }

    observe() {
        this.elements.forEach(item => {
            this.observer.observe(item);
        });
    }

    init() {
        this.observe();
    }
}

export const initObserver = (selector) => {
    const Observer = new IntersectionObserverAnimation(selector);
    Observer.init();
}
